import Vue from 'vue';
import Vuex from 'vuex';
import settings from './modules/settings';
import userModule from './modules/user';
import i18n from './modules/i18n';
import form from './modules/form';
import dropdownModule from './modules/dropdown';
import tasksModule from './modules/tasks';
import attachmentsModule from './modules/attachments';

let store = {};

function getStore() {
  return store;
}

Vue.use(Vuex);
export default function createStore() {
  store = new Vuex.Store({
    modules: {
      // permission, // import permission from './modules/permission'; - registered somewhere else because of cyclic dependency
      settings,
      userModule,
      i18n,
      dropdownModule,
      form,
      tasksModule,
      attachmentsModule,
    },
    state: {},
    mutations: {},
    actions: {},
    getters: {},
  });

  return store;
}

export { getStore };
